import React from "react";
import {
  MAIN_REASONS,
  DETECTION_TYPES,
} from "../../../RecipientDetail/sanctionConstants";

export const PRESENCE_OPTIONS = [
  { id: "PRESENT", label: "Présent" },
  { id: "PRESENT_ACCOMPAGNE", label: "Présent, accompagné(e)" },
  { id: "ABSENT", label: "Absent" },
  { id: "ABSENT_OBSERVATIONS_ECRITES", label: "Absent, observations écrites" },
  { id: "NON_CONVOQUE", label: "Non convoqué" },
];
export const PRESENCE_OPTIONS_SUPPRESSION = [
  { id: "PRESENT", label: "Présent" },
  { id: "PRESENT_ACCOMPAGNE", label: "Présent, accompagné(e)" },
  { id: "ABSENT", label: "Absent" },
  { id: "ABSENT_OBSERVATIONS_ECRITES", label: "Absent, observations écrites" },
];

export const getReasonLabel = (reasonId) => {
  const reason = Object.values(MAIN_REASONS).find((r) => r.id === reasonId);
  return reason?.label || reasonId;
};

export const getDetectionLabel = (detectionType) => {
  const labels = {
    [DETECTION_TYPES.PREMIER]: "Premier manquement",
    [DETECTION_TYPES.PERSISTANCE]: "Persistant",
    [DETECTION_TYPES.REITERATION]: "Réitération",
  };
  return labels[detectionType] || detectionType;
};

export const getDetectionStyle = (detectionType) => {
  const styles = {
    [DETECTION_TYPES.PREMIER]: {
      bg: "#d1ecf1",
      color: "#0c5460",
      border: "#17a2b8",
    },
    [DETECTION_TYPES.PERSISTANCE]: {
      bg: "#fff3cd",
      color: "#856404",
      border: "#ff9800",
    },
    [DETECTION_TYPES.REITERATION]: {
      bg: "#f8d7da",
      color: "#721c24",
      border: "#dc3545",
    },
  };
  return (
    styles[detectionType] || {
      bg: "#f8f9fa",
      color: "#333",
      border: "#dee2e6",
    }
  );
};

export const getSanctionStyle = (isSuppression) =>
  isSuppression
    ? {
        bg: "#fee2e2",
        color: "#991b1b",
        border: "#ef4444",
        label: "Suppression",
        icon: "fa-times-circle",
      }
    : {
        bg: "#fef3c7",
        color: "#92400e",
        border: "#f59e0b",
        label: "Suspension",
        icon: "fa-pause-circle",
      };

export const SectionHeader = ({ icon, iconBg, title, subtitle }) => (
  <div className="d-flex align-items-center mb-3" style={{ gap: 10 }}>
    <div
      className="d-flex align-items-center justify-content-center flex-shrink-0"
      style={{
        width: 32,
        height: 32,
        borderRadius: 8,
        background:
          iconBg ||
          "linear-gradient(135deg, rgb(30, 58, 95) 0%, rgb(37, 99, 235) 100%)",
      }}
    >
      <i className={`fa ${icon}`} style={{ fontSize: 14, color: "#fff" }} />
    </div>
    <div>
      <div style={{ fontSize: 14, fontWeight: 700, color: "#1e293b" }}>
        {title}
      </div>
      {subtitle && (
        <div style={{ fontSize: 12, color: "#94a3b8" }}>{subtitle}</div>
      )}
    </div>
  </div>
);
